import React from 'react';
import { Backdrop, Box } from '@mui/material';

const GatewayLoadingIndicator = ({ isLoading }) => {
  return (
    <Backdrop
      sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
      open={isLoading}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: '80px',
            height: '80px',
            backgroundColor: '#212121',
            border: '1px solid hsl(0, 0.00%, 20%)',
            borderRadius: '35%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <svg
            width="50"
            height="50"
            viewBox="0 0 40 40"
            style={{ animation: 'spin 1s linear infinite' }}
          >
            <defs>
              <linearGradient
                id="my_gradient"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop offset="0%" stopColor="hsl(63, 100%, 20%)" />
                <stop offset="100%" stopColor="hsl(63, 100%, 70%)" />
              </linearGradient>
            </defs>
            <circle
              cx="20"
              cy="20"
              r="16"
              stroke="url(#my_gradient)"
              strokeWidth="2"
              fill="none"
            />
          </svg>

          {/* Add the animation keyframes */}
          <style>
            {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                svg {
                  transform-origin: center;
                }
              `}
          </style>
        </div>
      </Box>
    </Backdrop>
  );
};

export default GatewayLoadingIndicator;
